import { jsx as _jsx } from "react/jsx-runtime";
import { createSelector } from '@reduxjs/toolkit';
import { Children } from 'react';
import { IntlProvider } from 'react-intl';
import { connect } from 'react-redux';
import { DEFAULT_LANGUAGE } from './translations-constants';
import { selectLanguage, selectMessages } from './translations-selectors';
export const LanguageProvider = ({ language, children, messages }) => (_jsx(IntlProvider, { textComponent: "span", defaultLocale: DEFAULT_LANGUAGE, locale: language, messages: messages, onError: () => { }, children: Children.only(children) }, language));
const mapStateToProps = createSelector([selectLanguage, selectMessages], (language, messages) => ({
    language,
    messages,
}));
const ConnectedLanguageProvider = connect(mapStateToProps)(LanguageProvider);
ConnectedLanguageProvider.displayName = 'ConnectedLanguageProvider';
export default ConnectedLanguageProvider;
